export const isDateOverdue = (
  dateString: string | null | undefined,
  componentName = 'unknown'
): boolean => {
  if (!dateString || dateString === '—' || dateString === '') return false;

  try {
    let dueDate: Date;

    // Case 1: ISO datetime format with timezone (e.g., 2025-12-01T19:55:20.000000000+00:00)
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(dateString)) {
      // Extract just the date part from the ISO string to avoid timezone conversion issues
      const datePart = dateString.split('T')[0]; // Get "2025-12-01" from "2025-12-01T19:55:20.000000000+00:00"
      const parts = datePart.split('-').map(Number);
      dueDate = new Date(parts[0], parts[1] - 1, parts[2]); // Create date without timezone conversion
    }

    // Case 2: Simple ISO date format (YYYY-MM-DD)
    else if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      const parts = dateString.split('-').map(Number);
      dueDate = new Date(parts[0], parts[1] - 1, parts[2]);
    }

    // Case 3: Slash format (DD/MM/YYYY or MM/DD/YYYY)
    else if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
      const parts = dateString.split('/').map(Number);
      // Assuming DD/MM/YYYY format
      dueDate = new Date(parts[2], parts[1] - 1, parts[0]);
    } else {
      console.log(
        'Unsupported date format:',
        dateString,
        'from component:',
        componentName
      );
      return false; // unsupported format
    }

    // Check if date is valid
    if (isNaN(dueDate.getTime())) {
      console.log(
        'Invalid date:',
        dateString,
        'from component:',
        componentName
      );
      return false;
    }

    // Today at local midnight
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    const isOverdue = dueDate < today;

    return isOverdue;
  } catch (error) {
    return false;
  }
};
